var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes, useTheme } from 'styled-components';
import Avatar from '../../Elements/Avatar/Avatar';
import Box from '../../Layout/Flex/Box';
import Spacer from '../../Layout/Spacer/Spacer';
const loadingOpacity = keyframes `
    0% {opacity: 0 }
    80% {opacity: 0}
    100% {opacity: 1}
`;
const LoadingStyle = styled.div `
  opacity: 0;
  position: ${(props) => props.position};
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 6rem;
  animation: ${props => props.delay + 'ms'} ${loadingOpacity} forwards;
`;
const pathLoading = keyframes `
    from {stroke-dashoffset: 0 }
    to {stroke-dashoffset: 300}
`;
const ImageStyle = styled.svg `
  path {
    stroke-width: 1px;
    fill: none;
    stroke: ${(props) => props.secondary === true ? props.theme.colors.secondaryColor : props.theme.colors.mainColor};
    stroke-dasharray: 300;
    stroke-dashoffset: 0;
    stroke-width: 1.5px;
    animation: 4s ${pathLoading} infinite;
    animation-direction: alternate;
    animation-delay: ${props => props.delay + 'ms'}
  }
  .cls-2{
    stroke: ${(props) => props.secondary === true ? props.theme.colors.mainColor : props.theme.colors.secondaryColor};
  }
  .cls-3{
    animation-delay: ${props => (props.delay + 1200) + 'ms'}
  }
`;
const CustomLoadingContainer = styled.div `
  left: 50%;
  margin: 0;
  background-color: ${props => props.theme.colors.greyColor};
  height: 5px;
  overflow: hidden;
  width: 12em;
  border-radius: ${props => props.theme.borders.borderRadius}
`;
const bouncingLoading = keyframes `
  0%, 100% { transform: translateX(-50%); }
  50% { transform: translateX(150%); }
`;
const CustomLoading = styled.div `
  animation: ${bouncingLoading} 2s ease-in-out infinite;
  background-color: ${props => props.secondary ? props.theme.colors.secondaryColor : props.theme.colors.mainColor};
  height: 100%;
  position: relative;
  width: 50%;
`;
const Loading = (_a) => {
    var { position = 'absolute', secondary = false, delay = 2000 } = _a, props = __rest(_a, ["position", "secondary", "delay"]);
    const theme = useTheme();
    return (_jsx(LoadingStyle, Object.assign({ position: position, delay: delay }, props, { children: theme.logo
            ? _jsxs(Box, Object.assign({ column: true, justifyContent: 'center', alignItems: 'center' }, { children: [_jsx(Avatar, { avatar: theme.logo, size: '4rem', style: { backgroundColor: theme.colors.mainColor, padding: theme.paddingsMargins.themeMenuPadding } }), _jsx(Spacer, { vertical: true, half: true }), _jsx(CustomLoadingContainer, { children: _jsx(CustomLoading, { secondary: secondary }) })] }))
            : _jsx(ImageStyle, Object.assign({ delay: delay, secondary: secondary, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 345.24 65.06" }, { children: _jsx("g", Object.assign({ id: "Livello_2", "data-name": "Livello 2" }, { children: _jsxs("g", Object.assign({ id: "Livello_1-2", "data-name": "Livello 1" }, { children: [_jsx("path", { className: "cls-1", d: "M95.79,35.87a11.31,11.31,0,0,1-19.71,1,12.11,12.11,0,0,1,1.24-13.61l.26-.26a11.55,11.55,0,0,1,3.3-2.37,12.1,12.1,0,0,1,4.82-1,12.53,12.53,0,0,1,4.11.73,11.63,11.63,0,0,1,5.24,4.21,12.27,12.27,0,0,1,.76,11.28M105,23V13.13H96.69l-1.3,1.94a19.69,19.69,0,0,0-2.18-1.15L93,13.83l-.41-.17a16.79,16.79,0,0,0-3.47-1,18.57,18.57,0,1,0-3.46,36.82h0A17.82,17.82,0,0,0,89,49.17h.06c.34-.06.67-.13,1-.22h.16l1.12-.33h0a18.62,18.62,0,0,0,3.42-1.51l1.87,2.3H105Z" }), _jsx("path", { className: "cls-1", d: "M155.47,49.33a18.56,18.56,0,0,0,14.45-7.07l-5.08-5.08A11.29,11.29,0,0,1,146,36.73a12.12,12.12,0,0,1,1.21-13.6l.11-.1a11.65,11.65,0,0,1,3.46-2.53,12.45,12.45,0,0,1,4.82-1,12.79,12.79,0,0,1,4.11.73A11.32,11.32,0,0,1,163.83,23,10.91,10.91,0,0,1,165,24.45c.11.16.2.33.3.5L167.16,23l3.23-3.24a18.67,18.67,0,0,0-8.2-6.38h-.05a16.3,16.3,0,0,0-3.07-.87,19,19,0,0,0-3.45-.32h-1.06A18.61,18.61,0,0,0,137.42,27h0a4.54,4.54,0,0,1-.13.72,18.57,18.57,0,0,0,18.22,21.57" }), _jsx("path", { className: "cls-1", d: "M134.51,41.26c-4.13-.1-10.91,1.26-11.19-4.84V20h7.23l3.94-6.85H123.32V0h-8.26V13.15h-5.38V20h5.38V32.65c-.23,4.55.07,9.7,3.69,12.93,3.71,4.24,10.59,3.71,15.76,3.65Z" }), _jsx("path", { className: "cls-1", d: "M193.84,12.16a18.19,18.19,0,0,0-10.28,3.15V.05h-8.34V49.38h8.38V30.52h0a10.2,10.2,0,0,1,20.39,0h0V49.41h8.16V30.51a18.4,18.4,0,0,0-18.36-18.36" }), _jsx("path", { className: "cls-1", d: "M328.75,36.46V20H336l3.94-6.85H328.75V0h-8.27V13.15H315.1V20h5.38V32.65c-.23,4.55.08,9.7,3.69,12.92,3.72,4.25,10.59,3.72,15.76,3.66v-8c-4.13-.1-10.91,1.26-11.18-4.84" }), _jsx("path", { className: "cls-1", d: "M44.61,12.26a17.75,17.75,0,0,0-13.42,6.15A17.75,17.75,0,0,0,0,30H0V49.3H8.68V30h0a9.09,9.09,0,0,1,18.17-.19v.12h0V49.26h8.68V29.84A9.08,9.08,0,0,1,53.69,30h0V49.3h8.68V30h0A17.8,17.8,0,0,0,44.61,12.26" }), _jsx("path", { className: "cls-1", d: "M253.42,39h-8.79a11.35,11.35,0,1,1,.11-16l0,.05h8.74a18.52,18.52,0,0,0-20.27-10.37,16.53,16.53,0,0,0-3.46,1l-.42.17-.21.09A19.27,19.27,0,0,0,227,15l-1.29-1.94h-8.33v49.4h8.3V49.34h0l1.86-2.3A18.32,18.32,0,0,0,231,48.55h0c.37.12.74.23,1.11.32h.17c.34.08.68.16,1,.22h.06a18.59,18.59,0,0,0,20-10.16" }), _jsx("path", { className: "cls-1", d: "M301.13,15.06A17.43,17.43,0,0,0,299,13.92l-.22-.1-.42-.17a16.62,16.62,0,0,0-3.45-1,19.12,19.12,0,0,0-3.46-.32A18.55,18.55,0,0,0,274.6,23h8.72a11.34,11.34,0,1,1,.28,16l0,0h-8.79a18.58,18.58,0,0,0,15.71,10.43h1.78a18.07,18.07,0,0,0,2.55-.27h.06c.34-.06.67-.13,1-.22H296c.37-.1.75-.2,1.12-.33h0a18.62,18.62,0,0,0,3.42-1.51l1.87,2.3h0v.08h8.3V13.2h-8.32Z" }), _jsx("path", { className: "cls-2", d: "M240.79,27.26A5.43,5.43,0,0,0,239.05,26a6.11,6.11,0,0,0-2.35-.5,6.79,6.79,0,0,0-2,.36,5.62,5.62,0,0,0-2.56,2.06,6,6,0,0,0-.37,5.51,5.5,5.5,0,0,0,9.59.52h45.06A5.49,5.49,0,0,0,294,35.63a5.42,5.42,0,0,0,2-2.22,6,6,0,0,0-.37-5.51,5.6,5.6,0,0,0-2.55-2.06,6.79,6.79,0,0,0-2-.36,6.11,6.11,0,0,0-2.35.5A5.56,5.56,0,0,0,287,27.26a6,6,0,0,0-.47.65l-.06.1H241.32a5.06,5.06,0,0,0-.55-.76" }), _jsx("path", { className: "cls-1", d: "M258.91,0h8.35V23h-8.35V0Z" }), _jsx("path", { className: "cls-3", d: "M258.92,39h8.35V49.33h-8.35V39Z" })] })) })) })) })));
};
export default Loading;
